import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';
import RtlLayout from 'layouts/rtl';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import SignInCentered from "views/auth/signIn/index";
import { supabase } from 'api/supabase';
import QuestionnairePage from "views/preview/index";

import PageTitle from './PageTitle';

import DownloadPage from "views/auth/downloadPage/index";

import './api/global';

const titles = {
	'/preview': 'RewardGo',
	// Add more paths and titles as needed
};

const defaultTitle = 'RewardGo CMS'; // This will be used when no specific title is found
// Auto Logout Functionality
let logoutTimer;

// Function to reset inactivity timer
function resetInactivityTimer() {
  clearTimeout(logoutTimer); // Clear existing timer
  
  logoutTimer = setTimeout(async () => {
    console.log("User inactive, logging out...");
    
    try {
      await supabase.auth.signOut(); // Log out the user
    } catch (error) {
      console.error("Logout failed:", error);
    }

    window.location.href = "/auth/sign-in"; // Redirect to login page
  }, 15 * 60 * 1000); // 15 minutes
}

// Attach event listeners to detect user activity
window.addEventListener("mousemove", () => {
	console.log("Mouse moved");
	resetInactivityTimer();
  });
window.addEventListener("keydown", () => {
	console.log("Key pressed");
	resetInactivityTimer();
  });
window.addEventListener("touchstart", () => {
	console.log("Screen touched");
	resetInactivityTimer();
  });

// Start the inactivity timer initially
resetInactivityTimer();

ReactDOM.render(
	<ChakraProvider theme={theme}>
		<React.StrictMode>
			<ThemeEditorProvider>
				<HashRouter>
					<PageTitle titles={titles} defaultTitle={defaultTitle} />
					<Switch>
						<Route path={`/preview`} render={() => (
							<QuestionnairePage />
						)} />
						<Route path={`/auth`} component={AuthLayout} />
						<Route path={`/admin`} render={() => (
							localStorage.getItem('authenticated') ? (
								<AdminLayout />
							) : (
								<Redirect to="/auth/sign-in" />
							)
						)} />
						<Redirect from='/' to='/auth/sign-in'/>
					</Switch>
				</HashRouter>
			</ThemeEditorProvider>
		</React.StrictMode>
	</ChakraProvider>,
	document.getElementById('root')
);

